import { ApiResponse } from "../models/uomtypes";

const API_URL = "https://api-agamhive.agamvanigam.com/itemassignedracks";
export const UNAUTHORIZED_EVENT = "unauthorized_access";
const getAuthToken = () => localStorage.getItem("authToken") || "";

const handleUnauthorized = () => {
    console.error("Unauthorized access. Dispatching event for navigation...");
    localStorage.removeItem("authToken");
    
    const unauthorizedEvent = new CustomEvent(UNAUTHORIZED_EVENT);
    window.dispatchEvent(unauthorizedEvent);
    return { error: "Unauthorized. Please log in." };
};

export const createItemAssignment = async (itemId: string, rackId: string): Promise<ApiResponse<any>> => {
    const token = getAuthToken();
    if (!token) return handleUnauthorized();

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ itemId, rackId }), 
        });
        if (response.status === 401) {
            return handleUnauthorized();
        }
        const data = await response.json();
        return response.ok ? { data } : { error: data?.msg || "Failed to create item assignment." };
    } catch (error) {
        return { error: "Network error. Please check your connection and try again." };
    }
};

export const fetchItemAssignments = async (page: number = 1, limit: number = 10): Promise<ApiResponse<any>> => {
    const token = getAuthToken();
    if (!token) return handleUnauthorized();

    try {
        const response = await fetch(`${API_URL}?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (response.status === 401) {
            return handleUnauthorized();
        }

        const jsonResponse = await response.json();
        if (!response.ok) {
            return { error: jsonResponse.msg || "Failed to fetch item assignments" };
        }

        return {
            data: jsonResponse.data.data || [],
        };
    } catch (error) {
        return { error: "Network error. Please try again." };
    }
};

export const updateItemAssignment = async (id: string, itemId: string = "", rackId: string = "", status: string = "ACTIVE"): Promise<ApiResponse<any>> => {
    const token = getAuthToken();
    if (!token) return handleUnauthorized();

    try {
        const response = await fetch(`${API_URL}/${id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ itemId, rackId, status }), 
        });
        if (response.status === 401) {
            return handleUnauthorized();
        }

        const data = await response.json();
        return response.ok ? { data } : { error: data?.msg || "Failed to update item assignment." };
    } catch (error) {
        return { error: "Network error. Please check your connection and try again." };
    }
};